import { render, staticRenderFns } from "./clinica.vue?vue&type=template&id=cb2e48ca&"
import script from "./clinica.vue?vue&type=script&lang=js&"
export * from "./clinica.vue?vue&type=script&lang=js&"
import style0 from "./clinica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports